// src/bootstrap/requireEnv.ts
// Runtime environment variable validation
// Used to show setup screen before Firebase initialization

export type EnvStatus =
  | { ok: true }
  | { ok: false; missing: string[] };

const REQUIRED = [
  "VITE_FIREBASE_API_KEY",
  "VITE_FIREBASE_AUTH_DOMAIN",
  "VITE_FIREBASE_PROJECT_ID",
  "VITE_FIREBASE_STORAGE_BUCKET",
  "VITE_FIREBASE_MESSAGING_SENDER_ID",
  "VITE_FIREBASE_APP_ID",
  "VITE_FIREBASE_FUNCTIONS_REGION",
] as const;

export function checkRequiredEnv(): EnvStatus {
  const missing = REQUIRED.filter((k) => {
    const v = (import.meta.env as Record<string, unknown>)[k];
    return !v || String(v).trim().length === 0;
  });

  if (missing.length > 0) return { ok: false, missing: [...missing] };
  return { ok: true };
}
